var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EF5350"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7663 16L23.0504 9.71585C23.1519 9.61429 23.2088 9.47659 23.2088 9.33305C23.2087 9.18951 23.1516 9.05187 23.05 8.95043C22.9485 8.84898 22.8108 8.79204 22.6672 8.79211C22.5237 8.79219 22.3861 8.84929 22.2846 8.95085L16.0004 15.2342L9.71712 8.95085C9.66689 8.90056 9.60724 8.86066 9.54159 8.83343C9.47594 8.80619 9.40557 8.79215 9.33449 8.79211C9.26342 8.79208 9.19303 8.80604 9.12735 8.8332C9.06167 8.86036 9.00199 8.9002 8.9517 8.95043C8.85014 9.05187 8.79305 9.18951 8.79297 9.33305C8.79293 9.40413 8.80689 9.47451 8.83405 9.54019C8.86122 9.60587 8.90105 9.66556 8.95128 9.71585L15.2346 16L8.95128 22.2842C8.90105 22.3345 8.86122 22.3942 8.83405 22.4598C8.80689 22.5255 8.79293 22.5959 8.79297 22.667C8.79301 22.738 8.80705 22.8084 8.83428 22.8741C8.86152 22.9397 8.90141 22.9994 8.9517 23.0496C9.00199 23.0998 9.06167 23.1397 9.12735 23.1668C9.19303 23.194 9.26342 23.2079 9.33449 23.2079C9.40557 23.2079 9.47594 23.1938 9.54159 23.1666C9.60724 23.1394 9.66689 23.0995 9.71712 23.0492L16.0004 16.7658L22.2846 23.0492C22.3348 23.0995 22.3945 23.1394 22.4601 23.1666C22.5258 23.1938 22.5962 23.2079 22.6672 23.2079C22.7383 23.2079 22.8087 23.194 22.8744 23.1668C22.9401 23.1397 22.9997 23.0998 23.05 23.0496C23.1003 22.9994 23.1402 22.9397 23.1675 22.8741C23.1947 22.8084 23.2087 22.738 23.2088 22.667C23.2088 22.5959 23.1948 22.5255 23.1677 22.4598C23.1405 22.3942 23.1007 22.3345 23.0504 22.2842L16.7663 16Z",
    fill: "#EF5350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close_red.2f582c68525e025f4eeaf2347ceda762.svg";
export { ForwardRef as ReactComponent };